import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'; // Import arrow icons (you can use any icon library you prefer)
import phoneFrame from "../assets/massiveSquarePhone.png";
import gameScreenVid from "../assets/gamePlayVideo.mp4";
import delighterVid from "../assets/delighter.mp4";
import playPokerAnytimeAnywhere from "../assets/PlayPokerAnytimeAnywhere.png"
import gameScreenPhoto from "../assets/question_1.png"
import delighterPhoto from "../assets/delighterPic.png"
import logo from "../assets/appLogo.png"
import IpadAndIphone from '../assets/ipadAndIphone10.webp';
import {
    ColourPalette,
    getAdjustingFontSizeByHeightWidth,
    getIsMobile,
    getIsTablet,
    getMobileDownloadButtonValues,
    getScreenSize,
    getSectionHeight,
} from "../globalConstants";
import { beginnerBannerText, downloadButtons, phoneFrameDimensions, adjustFontSizeForScreenWidth } from "../globalConstants";
import { Slide } from "@mui/material";
import { bulletPointSection, homeScreenTexts, styles, videoInPhone } from "./homeHelper";
import { sendLog } from "../App";
import { trackDownloadClick } from "../analytics/events";
import { LogoAndTagLineDesktop, LogoAndTagLineTablet, LogoAndTagLineMobile } from "./logoAndTagLine";
import { HorizontalScrollHero } from "./verticalPhoneWithVideo";
import StoreCreativeBackground from '../assets/storeCreativeBackgrounds2.png'; // Import the image
import StoreCreativeBackgroundNarrow from '../assets/storeCreativeBackgroundsNarrow2.png'; // Import the image
import TileDailyTournament from '../assets/Tile_DailyTournament.png'; // Import the image
import { FlexiblePhone } from "./flexiblePhone";
import gameScreen from "../assets/gamePlayVideo.mp4";
import delighter from "../assets/delighterVideoJun26.mp4";
import resultsScreen from "../assets/resultsScreen.mp4"
export function backgroundDiv(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean, showLogo: boolean = true): JSX.Element {
    return (
        <div
            style={{
                position: "absolute",
                height: "100%",
                top: 0,
                left: 0,
                width: "100%",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                background: isMobileOrTablet
                    ? 'linear-gradient(0deg,  rgba(186, 234, 201) 0%,   rgba(219, 243, 226) 100%)'
                    : 'linear-gradient(90deg,  rgba(186, 234, 201) 0%,   rgba(219, 243, 226) 100%)'
            }}
        >
            {showLogo && <img
                src={isMobileOrTablet ? StoreCreativeBackgroundNarrow : StoreCreativeBackground} // Reference the imported image
                alt="Daily Tournament Tile" // Provide an alt attribute
                style={{
                    width: "100%", // Example responsive styling
                    height: '100%',
                    objectFit: 'cover',
                    position: "absolute",
                    top: 0,
                    right: 0
                }}
            />}
            {/* <img
                src={TileDailyTournament} // Reference the imported image
                alt="Daily Tournament Tile" // Provide an alt attribute
                style={{
                    width: isMobile ? '100%' : '50%', // Example responsive styling
                    height: 'auto',
                    objectFit: 'contain',
                    position: "absolute",
                    top: 0,
                    right: 0
                }}
            /> */}
            {/* {isMobileOrTablet ? null : <div style={{
                height: "100%", width: "100%", opacity: 1,

                background:
                    'linear-gradient(135deg, rgba(256,256,256,0) 0%,  rgba(256,256,256,0.6) 15%,rgba(256,256,256,0.6) 60%, rgba(256,256,256,0) 75%,rgba(256,256,256,0) 100%)'
                , position: "absolute", zIndex: 1,
                filter: isMobileOrTablet ? 'blur(50px)' : 'blur(5px)'
            }}></div>} */}
            {/* <div
                style={{
                    position: "absolute",
                    height: "100%",
                    top: 0,
                    left: 0,
                    width: "100%",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    backgroundImage: "url(" + logo + ")",
                    backgroundSize: isMobile ? "200px" : (isTablet ? "350px" : "320px")
                }}
            >
            </div> */}
            {/* <div
                style={{
                    position: "absolute",
                    height: "100%",
                    top: 0,
                    left: 0,
                    width: "100%",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    background: isMobileOrTablet ?
                        'linear-gradient(180deg, rgba(0, 163, 54,0) 0%, rgba(0, 163, 54,0) 35%, rgba(0, 163, 54,1) 45%,rgba(0, 163, 54,1) 65%, rgba(0, 118, 39,1) 90%)'
                        :
                        'linear-gradient(90deg,  rgba(52, 191, 98, 0.95) 0%,  rgba(98, 204, 134, 0.95) 35%,  rgba(181, 239, 200, 0.95) 53%,  rgba(221, 255, 232,0.3) 100%)'
                }}
            >
            </div> */}
            {isMobileOrTablet && <div
                style={{
                    position: "absolute",
                    height: "100%",
                    top: 0,
                    left: 0,
                    width: "100%",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    background: isMobileOrTablet ?
                        'linear-gradient(180deg, rgba(256,256,256,0.4) 0%, rgba(256,256,256,0.4) 35%, rgba(0, 163, 54,0) 53%, rgba(0, 193, 64,0) 100%)'
                        :
                        'linear-gradient(90deg,  rgba(186, 234, 201) 0%,   rgba(219, 243, 226) 100%)'
                }}
            >
            </div>}

        </div>

    )
}

function textTop(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean): JSX.Element {
    return (
        <div
            className="home-text-top"
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: isMobileOrTablet ? "100%" : "60%"
            }}
        >
            {!isMobile ? <div style={{ height: "11.7%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
            </div> : null}
            <div style={{
                height: isMobileOrTablet ? "40%" : "47.6%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center"
            }}>
                <img style={{ objectFit: "contain", height: "100%", width: isMobile || isTablet ? "100%" : "75%" }} src={playPokerAnytimeAnywhere} />
            </div>
            <div
                className="home-rating-section"
                style={{
                    display: "flex",
                    height: isMobileOrTablet ? (isMobile ? "5%" : "20%") : "5%",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0rem 0.25rem",
                    fontSize: "15px", //TODO COME BACK TO THIS
                }}
            >
                {/* <Rating
                    name="text-feedback"
                    defaultValue={homeScreenTexts.rating}
                    precision={0.01}
                    size="large"
                    readOnly
                />
                <Box>
                    <p style={{ color: "#FFDD68" }}>
                        <b>{homeScreenTexts.rating}/5 </b>
                        {homeScreenTexts.noOfReviews} reviews
                    </p>
                </Box> */}
            </div>
            <div style={{ height: isMobileOrTablet ? "40%" : "29%", display: "flex", padding: "1%" }}>
                <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p
                        className="main-page-text"
                        style={{
                            display: "inline",
                            textAlign: "justify",
                            textJustify: "inter-word",
                            flexDirection: "column",
                            paddingLeft: "5%",
                            paddingRight: "5%",
                            fontSize: isMobile ? adjustFontSizeForScreenWidth(17) : adjustFontSizeForScreenWidth(24),
                            width: "80%",
                            maxHeight: "100%",
                            color: "#FFDD68",
                            flex: 1,
                            alignItems: "center",
                            justifyItems: "center",
                        }}
                        dangerouslySetInnerHTML={{
                            __html: homeScreenTexts.primaryBody,
                        }}
                    ></p>
                </div>
            </div>
        </div>
    )
}

function textBottom(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean) {
    return (
        <div
            className="home-text-section-bottom"
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: isMobileOrTablet ? "100%" : "40%"
            }}
        >
            <div className="download" style={{
                display: "flex",
                flex: 1,
                height: "100%",
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <div style={{ display: "flex", height: "100%", width: "100%", flex: 1, paddingLeft: "5%", paddingRight: "5%" }}>
                    <div
                        className="download-buttons"
                        style={styles.downloadButtons}
                    >
                        {isMobile ? (<div
                            className="button-container"
                            style={
                                {
                                    display: "flex",
                                    justifyContent: "space-around",
                                    flexDirection: "column",
                                    flex: 1,
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center"
                                }
                            }
                        >
                            <div style={{ display: "flex", width: "100%", flex: 1, justifyContent: "center", alignItems: "center" }}>
                                <img
                                    src={getMobileDownloadButtonValues().source}
                                    className="download-image"
                                    style={{
                                        height: "100%",
                                        width: "75%",
                                        maxWidth: isMobile ? "300px" : 0,
                                        objectFit: "contain",
                                    }}
                                    alt=""
                                    onClick={(e) => {
                                        sendLog("Home! Clicked Download Button in text Bottom")
                                        // alert("Pocket Poker is not available for download until 2nd Stay Tuned! Pocket Poker is awaiting app store approval and will be available for download soon.ber 2023")
                                        // // e.preventDefault();
                                        const link = getMobileDownloadButtonValues().link;
                                        trackDownloadClick(link, "lead_section");
                                        window.open(link);
                                    }}
                                />
                            </div>
                            <div style={{ display: "flex", width: "100%", flex: 1, justifyContent: "center", alignItems: "center", flexDirection: "row", marginLeft: "12.5%" }}>
                                {bulletPointSection(homeScreenTexts.bulletPointsLeft.concat(homeScreenTexts.bulletPointsRight))}
                            </div>
                        </div>)
                            : downloadButtons.map((button, i) => {
                                console.log("i:" + i)
                                const isLeft: boolean = (i % 2 == 0)
                                return (
                                    <div
                                        className="button-container"
                                        style={
                                            {
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                flex: 1,
                                                width: "50%",
                                                height: "100%",
                                                alignItems: "center",
                                            }
                                        }
                                    >
                                        <div style={{ display: "flex", height: "100%", width: "100%", flex: 1, justifyContent: "center", alignItems: "center" }}>
                                            <img
                                                src={button.source}
                                                className="download-image"
                                                style={{
                                                    height: "100%",
                                                    width: "75%",
                                                    objectFit: "contain",
                                                }}
                                                alt=""
                                                onClick={(e) => {
                                                    sendLog("Home! Clicked Download Button with id " + i.toString())
                                                    // alert("Stay Tuned! Pocket Poker is awaiting app store approval and will be available for download soon.")
                                                    e.preventDefault();
                                                    trackDownloadClick(button.link, "lead_section");
                                                    window.open(button.link);
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: "flex", height: "100%", width: "100%", flex: 1, justifyContent: "center", alignItems: "center", marginLeft: "12.5%" }}>
                                            {isLeft ? bulletPointSection(homeScreenTexts.bulletPointsLeft) : bulletPointSection(homeScreenTexts.bulletPointsRight)}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </div >
    )
}

function textAndButtonsDesktop(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean): JSX.Element {
    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", position: "relative" }}>
            <div
                style={{
                    position: "relative",

                    height: "100%",
                    flexDirection: "column",
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 0,
                }}
            >
                {LogoAndTagLineDesktop()}
                {/* {textBottom(isMobile, isTablet, isMobileOrTablet)} */}
            </div>
        </div>
    )
}

export function videosInPhones(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean): JSX.Element {
    const screenSize = getScreenSize()
    const screenWidth = screenSize.width
    const screenHeight = screenSize.height
    const scaleFactor = isMobile ? Math.min(screenHeight / 700, screenWidth / 375) : (isTablet ? Math.max(Math.min(screenHeight / 800, screenWidth / 1100), 0.8) : Math.max(Math.min(screenHeight / 800, screenWidth / 1600), 0.8))
    return (
        <div style={{ width: "100%", height: "50%", display: "flex" }}>
            <div
                className="home-video-section"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%", zIndex: 2,
                    transition: "transform 0.3s ease", // Smooth transition
                }}
            // onMouseEnter={(e) => {
            //     if (!isMobileOrTablet) { e.currentTarget.style.transform = "scale(1.1)"; }
            // }}
            // onMouseLeave={(e) => {
            //     if (!isMobileOrTablet) { e.currentTarget.style.transform = "scale(1)" };
            // }}
            >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                    <div
                        className="overlapping-phones-section"
                        style={{
                            position: "absolute",
                            height: getIsMobile() ? phoneFrameDimensions.height.mobile : phoneFrameDimensions.height.desktop,
                            width: getIsMobile() ? phoneFrameDimensions.width.mobile : phoneFrameDimensions.width.desktop,
                            transform: 'scale(' + (scaleFactor.toString()) + "," + (scaleFactor.toString()) + ')'
                        }}
                    >
                        {videoInPhone(gameScreenVid, "-15", isMobile ? "-30%" : (isTablet ? -100 : -120), isMobile ? -10 : (isTablet ? 20 : 0), 3, gameScreenPhoto)}
                        {videoInPhone(delighterVid, "15", isMobile ? "22%" : (isTablet ? 60 : 60), isMobile ? 50 : (isTablet ? 60 : 60), 2, delighterPhoto)}
                    </div>
                </Slide>
            </div>
        </div>
    )
}
export function HorizontalScrollVideosInPhones(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean): JSX.Element {
    const screenSize = getScreenSize();
    const screenWidth = screenSize.width;
    const screenHeight = screenSize.height;
    const scaleFactor = isMobile ? screenWidth / 300 : 1.08
    const [leftZIndex, setLeftZIndex] = useState(2); // zIndex for the left video
    const [rightZIndex, setRightZIndex] = useState(1); // zIndex for the right video

    const left = [isMobileOrTablet ? "-130%" : "-180%", 30, leftZIndex];
    const middle = [0, 0, 4];
    const right = [isMobileOrTablet ? "130%" : "180%", 30, rightZIndex];

    const [rotationState, setRotationState] = useState<(0 | 1 | 2)>(0);
    const [hasSwiped, setHasSwiped] = useState(false); // Track if user has swiped

    // Video refs to control playback
    const videoRefs = useRef<(HTMLVideoElement | null)[]>([null, null, null]);
    const [videoKeys, setVideoKeys] = useState([0, 0, 0]); // Force re-render of videos

    function getText() {
        return rotationState == 1 ? "Get instant analysis of after every hand for fast and focused learning" :
            (rotationState == 2 ? "Challenge friends or compete in the global league anytime anywhere" :
                "View your progress and most common mistakes Over Time")
    }

    // Function to replay video when it comes to middle
    const handleVideoReplay = (videoIndex: number) => {
        const video = videoRefs.current[videoIndex];
        if (video) {
            video.currentTime = 0;
            video.play().catch(e => console.log("Video play failed:", e));
        }
    };

    // Effect to handle video replay when rotation state changes
    useEffect(() => {
        // Small delay to ensure the video is in the middle position
        const timer = setTimeout(() => {
            handleVideoReplay(rotationState);
        }, 100);

        return () => clearTimeout(timer);
    }, [rotationState]);

    const phoneBorderRadius = !isMobileOrTablet ? getScreenSize().height * 0.1 : 35
    const carosell = [
        <div style={{
            width: "100%", height: "100%", position: "absolute",
            left: (rotationState == 0 ? middle : (rotationState == 1 ? left : right))[0],
            bottom: (rotationState == 0 ? middle : (rotationState == 1 ? left : right))[1],
            zIndex: (rotationState == 0 ? middle : (rotationState == 1 ? left : right))[2],
            opacity: rotationState == 0 ? 1 : 0,
            transition: rotationState == 0 ? "left 0.5s ease, bottom 0.5s ease, opacity 0.5s ease 0.2s" : "left 0.5s ease, bottom 0.5s ease, opacity 0.3s ease", // Add smooth transition for 'left' and 'bottom'
        }}>
            <FlexiblePhone
                style={{ width: "100%", height: "100%", position: "relative" }}
                videoBorderRadius={phoneBorderRadius * 0.8}
                marginHorizontal={"3%"}
                marginTop={"1%"}
                video={gameScreen}
                videoRef={(ref) => videoRefs.current[0] = ref}
                videoKey={videoKeys[0]}
            />
        </div>,
        <div style={{
            width: "100%", height: "100%", position: "absolute",
            left: rotationState === 1 ? middle[0] : (rotationState === 2 ? left[0] : right[0]),
            bottom: rotationState === 1 ? middle[1] : (rotationState === 2 ? left[1] : right[1]),
            zIndex: rotationState === 1 ? middle[2] : (rotationState === 2 ? left[2] : right[2]),
            opacity: rotationState == 1 ? 1 : 0,
            transition: rotationState == 1 ? "left 0.5s ease, bottom 0.5s ease, opacity 0.5s ease 0.2s" : "left 0.5s ease, bottom 0.5s ease, opacity 0.3s ease", // Add smooth transition for 'left' and 'bottom'
        }}>
            <FlexiblePhone
                style={{ width: "100%", height: "100%", position: "relative" }}
                videoBorderRadius={phoneBorderRadius * 0.8}
                marginHorizontal={"3%"}
                marginTop={"1%"}
                video={delighter}
                videoRef={(ref) => videoRefs.current[1] = ref}
                videoKey={videoKeys[1]}
            />
        </div>,
        <div style={{
            width: "100%", height: "100%", position: "absolute",
            left: rotationState === 2 ? middle[0] : (rotationState === 0 ? left[0] : right[0]),
            bottom: rotationState === 2 ? middle[1] : (rotationState === 0 ? left[1] : right[1]),
            zIndex: rotationState === 2 ? middle[2] : (rotationState === 0 ? left[2] : right[2]),
            opacity: rotationState == 2 ? 1 : 0,
            transition: rotationState == 2 ? "left 0.5s ease, bottom 0.5s ease, opacity 0.5s ease 0.2s" : "left 0.5s ease, bottom 0.5s ease, opacity 0.3s ease", // Add smooth transition for 'left' and 'bottom'
        }}>
            <FlexiblePhone
                style={{ width: "100%", height: "100%", position: "relative" }}
                videoBorderRadius={phoneBorderRadius * 0.8}
                marginHorizontal={"3%"}
                marginTop={"1%"}
                marginBottom={"4%"}
                videoRef={(ref) => videoRefs.current[2] = ref}
                videoKey={videoKeys[2]}
                video={resultsScreen}
                banner={beginnerBannerText}
            />
        </div>
    ];

    // Swipe handling
    let touchStartX = 0;
    let touchEndX = 0;

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartX = e.changedTouches[0].screenX;
    };

    const handleTouchEnd = (e: React.TouchEvent) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipeGesture();
    };

    const handleSwipeGesture = () => {
        if (!hasSwiped) {
            setHasSwiped(true); // Set swipe flag on first swipe
        }

        if (touchEndX < touchStartX) {
            // Swiped left, move to the next carousel item
            setRotationState((prevRotationState) => (prevRotationState + 1) % 3 as 0 | 1 | 2);
            // If swiping left, right gets higher zIndex
            setRightZIndex(2);
            setLeftZIndex(3);

        } else if (touchEndX > touchStartX) {
            // Swiped right, move to the previous carousel item
            setRotationState((prevRotationState) => (prevRotationState - 1 + 3) % 3 as 0 | 1 | 2);
            // If swiping right, left gets higher zIndex
            setRightZIndex(3);
            setLeftZIndex(2);

        }
    };

    const handleArrowClick = (direction) => {
        if (!hasSwiped) {
            setHasSwiped(true); // Set swipe flag on first swipe
        }

        if (direction === 'left') {
            setRotationState((prevRotationState) => (prevRotationState - 1 + 3) % 3 as 0 | 1 | 2);
            // Adjust zIndex if needed
            setRightZIndex(3);
            setLeftZIndex(2);
        } else {
            setRotationState((prevRotationState) => (prevRotationState + 1) % 3 as 0 | 1 | 2);
            // Adjust zIndex if needed
            setLeftZIndex(3);
            setRightZIndex(2);
        }

    };

    const chevronSize = isMobileOrTablet ? getScreenSize().width / 1920 * 30 : getScreenSize().width / 1920 * 50
    // Add state to track video durations
    const videoDurations = useRef([16000, 8000, 30000]); // durations in milliseconds

    useEffect(() => {
        let timeoutId: NodeJS.Timeout | null = null;

        // Only start auto-rotation if the user hasn't swiped yet
        if (!hasSwiped) {
            // Get the duration for the current video + 1 second delay
            const currentDuration = videoDurations.current[rotationState] + 1000;

            timeoutId = setTimeout(() => {
                setRotationState((prevRotationState) => ((prevRotationState + 1) % 3) as 0 | 1 | 2);
            }, currentDuration);
        }

        // Clean up the timeout on component unmount, rotation change, or if the user swipes
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [hasSwiped, rotationState]); // Added rotationState to dependencies
    if (isMobileOrTablet) {
        return null
    }
    return (
        <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
            <div
                className="home-video-section"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%",
                    zIndex: 2,
                    transition: "transform 0.3s ease", // Smooth transition
                }}

            >
                <div
                    className="overlapping-phones-section"
                    style={{
                        position: "absolute",
                        display: "flex",
                        height: getIsMobile() ? phoneFrameDimensions.height.mobile : getScreenSize().height * 0.40 * 2.02535,
                        width: getIsMobile() ? phoneFrameDimensions.width.mobile : getScreenSize().height * 0.40,
                        transform: 'scale(' + (scaleFactor.toString()) + "," + (scaleFactor.toString()) + ')'
                    }}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                >
                    {carosell}
                </div>

                {/* Left Arrow */}
                <div
                    style={{
                        position: 'absolute',
                        left: (Math.round(getScreenSize().width / 1920 * 25)).toString() + 'px',
                        top: '40%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        zIndex: 10,
                        borderRadius: 5,
                        backgroundColor: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 5,
                        transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for scale and shadow
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.5)", // Initial state without shadow
                    }}
                    onMouseEnter={(e) => {
                        if (!isMobileOrTablet) {
                            e.currentTarget.style.transform = "translateY(-50%) scale(1.2)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(229,189,23,0.8)"; // Shadow effect on hover
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!isMobileOrTablet) {
                            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.5)"; // Remove shadow on leave
                        }
                    }}
                    onTouchStart={(e) => {
                        // Add the touch feedback effect (same as hover effect)
                        e.currentTarget.style.transform = "translateY(-50%) scale(1.2)";
                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(229,189,23,0.8)"; // Golden glow on touch
                    }}
                    onTouchEnd={(e) => {
                        // Remove the touch feedback effect when touch ends
                        e.currentTarget.style.transform = "translateY(-50%) scale(1)";
                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.5)"; // Return to default shadow
                    }}
                    onClick={() => handleArrowClick('left')}
                >
                    <FaChevronLeft size={chevronSize} />
                </div>

                {/* Right Arrow */}
                <div
                    style={{
                        position: 'absolute',
                        right: (Math.round(getScreenSize().width / 1920 * 25)).toString() + 'px',
                        top: '40%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        zIndex: 10,
                        borderRadius: 5,
                        backgroundColor: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 5,
                        transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for scale and shadow
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.5)", // Initial state without shadow
                    }}
                    onMouseEnter={(e) => {
                        if (!isMobileOrTablet) {
                            e.currentTarget.style.transform = "translateY(-50%) scale(1.2)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(229,189,23,0.8)"; // Shadow effect on hover
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!isMobileOrTablet) {
                            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.5)"; // Remove shadow on leave
                        }
                    }}
                    onTouchStart={(e) => {
                        // Add the touch feedback effect (same as hover effect)
                        e.currentTarget.style.transform = "translateY(-50%) scale(1.2)";
                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(229,189,23,0.8)"; // Golden glow on touch
                    }}
                    onTouchEnd={(e) => {
                        // Remove the touch feedback effect when touch ends
                        e.currentTarget.style.transform = "translateY(-50%) scale(1)";
                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.5)"; // Return to default shadow
                    }}
                    onClick={() => handleArrowClick('right')}
                >
                    <FaChevronRight size={chevronSize} />
                </div>
            </div>
        </div>
    );
}

function mainDivDesktop(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean): JSX.Element {
    return (
        <div style={{
            height: getScreenSize().height * 0.8,
            width: "100%",
            flexDirection: "row",
            position: "relative",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        }}>
            {backgroundDiv(isMobile, isTablet, isMobileOrTablet, true)}
            <div style={{
                marginLeft: getScreenSize().width * 0.1,
                height: "100%",
                width: "40%",
                minWidth: "600px",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                {textAndButtonsDesktop(isMobile, isTablet, isMobileOrTablet)}
            </div>
            <div style={{
                height: "100%",
                marginLeft: "1%",
                width: "47%",
                minWidth: getIsMobile() ? phoneFrameDimensions.width.mobile : getScreenSize().height * 0.45,
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

            }}>
                <img
                    src={IpadAndIphone}
                    alt="Daily Tournament Tile"
                    style={{
                        width: '100%',
                        height: '95%',
                        objectFit: 'contain',
                        position: "absolute",
                        top: 0,
                        left: 0, padding: "5%"
                    }}
                />
                {/* {HorizontalScrollVideosInPhones(isMobile, isTablet, isMobileOrTablet)} */}
            </div>
        </div>
    )
}

function mainMobileOrTablet(isMobile: boolean, isTablet: boolean, isMobileOrTablet: boolean): JSX.Element {
    const widthReference = getScreenSize().width
    // alert(widthReference * 1.4 + ": " + getScreenSize().height)
    const heightReference = Math.min(getScreenSize().height, widthReference);
    return (
        <div style={{
            height: "auto",// isMobileOrTablet ? "92.5%" : "85%",
            width: "100%",
            flexDirection: isMobileOrTablet ? "column" : "row",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
            {backgroundDiv(isMobile, isTablet, isMobileOrTablet)}
            <div style={{
                display: "flex", flexDirection: "column", justifyContent: "center",
                height: isMobile ? "auto" : (getScreenSize().width > getScreenSize().height ? heightReference * 0.65 : heightReference * 0.55), width: "100%",

                marginTop: isMobile ? "4%" : "8%", marginBottom: getScreenSize().height < getScreenSize().width * 0.6 ? "20px" : null,
                minHeight: isMobile ? getScreenSize().width * 0.5 : null, position: "relative"
            }}>
                <div
                    style={{
                        position: "relative",
                        height: "100%",
                        flexDirection: "column",
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 0,
                        paddingLeft: isMobileOrTablet ? null : "10%"
                    }}
                >
                    {isMobile ? LogoAndTagLineMobile() : LogoAndTagLineTablet()}
                </div></div>
            {isMobile ? <div style={{
                height: heightReference * 0.7, marginLeft: "1%",
                width: "100%",
                minWidth: getScreenSize().height * 0.45,
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center", marginBottom: "5%"

            }}>
                <img
                    src={IpadAndIphone}
                    alt="Daily Tournament Tile"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        position: "absolute", paddingRight: "20px", paddingLeft: "20px",
                        top: 0,
                        left: 0,
                    }}
                />
            </div> : <div style={{
                height: heightReference * 0.8, marginLeft: "1%",
                width: "100%",
                minWidth: getScreenSize().height * 0.45,
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center", marginBottom: "5%"

            }}>
                <img
                    src={IpadAndIphone}
                    alt="Daily Tournament Tile"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        position: "absolute", paddingRight: "40px", paddingLeft: "40px",
                        top: 0,
                        left: 0,
                    }}
                />
            </div>}
            {/* <div style={{
                display: "flex", flexDirection: "column", justifyContent: "center",
                height: getScreenSize().height * 0.85, width: "100%", minHeight: getScreenSize().width * 1.15
            }}>
                {HorizontalScrollVideosInPhones(isMobile, isTablet, isMobileOrTablet)}
            </div> */}
            {/* <div style={{
                display: "flex", flexDirection: "column", justifyContent: "center",
                height: getScreenSize().height * 0, opacity: 0, width: "100%", minHeight: getScreenSize().width * 1.15 * 0
            }}>
                {HorizontalScrollVideosInPhones(isMobile, isTablet, isMobileOrTablet)}
            </div> */}
        </div>
    )
}

export function leadSection() {
    const isMobile: boolean = getIsMobile();
    const isTablet: boolean = getIsTablet();
    const isMobileOrTablet: boolean = isMobile || isTablet;

    return (
        isMobileOrTablet ?
            mainMobileOrTablet(isMobile, isTablet, isMobileOrTablet)
            :
            mainDivDesktop(isMobile, isTablet, isMobileOrTablet)
    )
}